export const TYPE_AM = 'am';
